import { param2Obj } from "@/utils/index";
import store from "./store";

const lang = param2Obj(location.search).lan;

store.commit("setLang", lang);
